import { SelectionTime, SelectionAny } from './internal';
import { parseExactDate } from '../parse';
export class SelectionDateExact extends SelectionAny {
    valueAsExactDate() {
        return this.value().map(parseExactDate);
    }
    getExactTime() {
        return this.get("TIME" /* Tag.Time */, null, SelectionTime);
    }
}
//# sourceMappingURL=SelectionDateExact.js.map